import { CryptoProError, CryptoProErrorCode } from './types';

// Значения констант CADESCOM_HASH_ALGORITHM_* из cadesplugin. Берём числа, а
// не cadesplugin.*, чтобы карта работала до инициализации плагина.
export const CADESCOM_HASH_ALGORITHM_SHA_256 = 4;
export const CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256 = 101;

// Карта URN из ответа MedicalDocuments/GetHash (поле HashAlgorithm) в
// константу алгоритма КриптоПро. Бэк на тестовом контуре отдаёт SHA-256
// (urn:sha256 — проверено живьём на dev 2026-07-17), после перехода на
// ГОСТ Р 34.11-2012 придёт другой URN — обе ветки должны работать без правок
// кода подписи. Константа CP_GOST_3411_2012_256 = 101 подтверждена POC на
// живом КриптоПро (подпись ГОСТ-хэша этим алгоритмом собралась в CAdES-BES).
// TODO(egisz-stage4, B3): сверить точную строку URN ГОСТ-алгоритма, когда
// бэк переключит тестовый GetHash на ГОСТ-хэш (ГОСТ-ключ не подписывает
// SHA-256 — сквозной прогон возможен только на ГОСТ-хэше).
const HASH_ALGORITHM_BY_URN: Record<string, number> = {
  'urn:sha256': CADESCOM_HASH_ALGORITHM_SHA_256,
  'urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34112012-256':
    CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256,
};

export const resolveHashAlgorithm = (hashAlgorithmUrn: string): number => {
  const algorithm = HASH_ALGORITHM_BY_URN[hashAlgorithmUrn];

  if (algorithm === undefined) {
    throw new CryptoProError(
      CryptoProErrorCode.UnknownHashAlgorithm,
      `Неизвестный алгоритм хэширования: ${hashAlgorithmUrn}`
    );
  }

  return algorithm;
};
